import { FC } from 'react'
import { StyledExpandLessIcon, StyledExpandMoreIcon } from './styled'

interface IProps {
  isExpanded: boolean
}

export const ExpandIcon: FC<IProps> = ({ isExpanded }) => {
  if (isExpanded) {
    return <StyledExpandLessIcon />
  }
  return <StyledExpandMoreIcon />
}
